import findIndex from 'lodash/findIndex';
import toNumber from 'lodash/toNumber';

export function move(
  source,
  destination,
  droppableSource,
  droppableDestination,
  draggableId
) {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const id = draggableId.match(/\d+/)[0];
  const index = findIndex(sourceClone, { id: toNumber(id) });
  const [removed] = sourceClone.splice(index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
}

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}
